import { createAsyncThunk, current } from '@reduxjs/toolkit';
import { axiosInstance } from '../../../utils/axiosInterceptor';

export const initStateReadChat = {
  readChat: { data: null, loading: false, error: null },
};

export const readChat = createAsyncThunk('user/readChat', async (data = {}, { rejectWithValue, fulfillWithValue }) => {
  return await axiosInstance
    .post(
      `${process.env.REACT_APP_SERVER_API}/chat/chats/${data}/read`,
      {},
      {
        headers: { Authorization: `Bearer ${localStorage.getItem('accessToken')}` },
      },
    )
    .then((res) => {
      return fulfillWithValue(res.data);
    })
    .catch((res) => {
      return rejectWithValue(res.response.data);
    });
});

export const reducerReadChat = {
  [readChat.pending]: (state) => {
    // state.readChat.data = null;
    state.readChat.loading = true;
    state.readChat.error = null;
  },
  [readChat.fulfilled]: (state, action) => {
    state.readChat.loading = false;
    state.readChat.data = action.payload;
    state.readChat.error = null;
  },
  [readChat.rejected]: (state, action) => {
    state.readChat.loading = false;
    state.readChat.error = action.payload;
  },
};
